"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var CancellationDelayRequest = /** @class */ (function () {
    function CancellationDelayRequest() {
    }
    return CancellationDelayRequest;
}());
exports.default = CancellationDelayRequest;
//# sourceMappingURL=CancellationDelayRequest.js.map